import { isPrimitive } from 'utils/common';
import { FilteringMultiValue, FilteringValue } from './DataGrid/DataGrid';

export type Nullable<T> = T | null | undefined;

/**
 * Limits the rate at which the passed in function is executed.
 * Commonly used for performance boosts.
 * @param func The function to be executed
 * @param waitFor (ms) The mininum time between executions
 */
export function debounce(func: Function, waitFor: number): Function {
  let timeout: number;

  return function (this: any, ...args: any[]) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), waitFor);
  };
}

/**
 * Comparator for exact match including empty string to all
 * @param value A string value
 * @param filter A string filter value
 */
export function filterMatch(value: string, filter: FilteringValue): boolean {
  return filter.value === '' || value === filter.value;
}

/**
 * Merge arrays of objects keeping unique values based on a field
 * (NOTE: The first array passed will take precedence over the rest)
 * @param arrays Arrays to merge
 * @param field Field which will determine singularity
 */
export function mergeArrays<T>(
  fieldId: string,
  ...arrs: Array<Array<any>>
): Array<T> {
  return (
    []
      // @ts-ignore
      .concat(...arrs)
      .reduce(
        (a: any, b: any) =>
          !a.filter((c: any) => b[fieldId] === c[fieldId]).length
            ? [...a, b]
            : a,
        []
      )
  );
}

/**
 * Comparator for include multi selector filter
 * @param val A string value
 * @param filter A FilteringMultiValue like { columName: 'name', filter: ['a', 'b'] }
 */
export function filterMulti(
  value: string,
  filter: FilteringMultiValue
): boolean {
  return (
    (filter && filter.value && filter.value.length === 0) ||
    filter.value.some((val: string) => value.includes(val))
  );
}
/**
 * Helper used for animation props normalization
 * @param initial
 * @param obj
 */
export const mergeAnimationProps = (initial: any, obj: any) =>
  typeof initial !== 'undefined' && isPrimitive(initial)
    ? initial
    : { ...obj, ...initial };
